import React from 'react';

const LayersIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M12 3l9 4.82-3.6 2.07 3.6 1.93-3.6 2.07 3.6 1.93L12 21l-9-5.18 3.6-1.93L3 11.82 6.6 9.9 3 7.82 12 3zM8.72 15.11l-1.45.78L12 18.6l4.73-2.72-1.45-.78L12 17l-3.28-1.89zm0-4l-1.45.78L12 14.6l4.73-2.72-1.45-.78L12 13l-3.28-1.89zM12 5.35L7.27 7.9 12 10.6l4.73-2.72L12 5.36z" />
  </svg>
);

export default LayersIcon;
